import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  CountRequest, FundDetail, FundRequest, FundUpdateRequest, PettyCashCount, PettyCashExpenseAccount, PettyCashFund, PettyCashReceipt,
  PettyCashVoucher, ReplenishRequest, Replenishment, ReplenishmentProposal, VoucherRequest,
} from '../interfaces/treasury.interface';

const E = ENDPOINTS.PETTY_CASH;

export const PettyCashService = {
  listFunds: async (institutionId: string): Promise<PettyCashFund[]> => (await axios.get(E.FUNDS(institutionId))).data,
  myFunds: async (): Promise<PettyCashFund[]> => (await axios.get(E.MY_FUNDS)).data,
  getFund: async (id: string): Promise<FundDetail> => (await axios.get(E.FUND_ONE(id))).data,
  createFund: async (body: FundRequest): Promise<PettyCashFund> => (await axios.post(E.FUND, body)).data,
  updateFund: async (id: string, body: FundUpdateRequest): Promise<PettyCashFund> => (await axios.put(E.FUND_ONE(id), body)).data,
  expenseAccounts: async (fundId: string): Promise<PettyCashExpenseAccount[]> =>
    (await axios.get(E.FUND_EXPENSE_ACCOUNTS(fundId))).data,
  closeFund: async (id: string): Promise<PettyCashFund> => (await axios.post(E.FUND_CLOSE(id))).data,
  listVouchers: async (fundId: string): Promise<PettyCashVoucher[]> => (await axios.get(E.FUND_VOUCHERS(fundId))).data,
  createVoucher: async (body: VoucherRequest): Promise<PettyCashVoucher> => (await axios.post(E.VOUCHER, body)).data,
  voidVoucher: async (id: string, reason: string): Promise<PettyCashVoucher> =>
    (await axios.post(E.VOUCHER_VOID(id), { reason })).data,
  listReceipts: async (voucherId: string): Promise<PettyCashReceipt[]> => (await axios.get(E.RECEIPTS(voucherId))).data,
  uploadReceipt: async (voucherId: string, file: File): Promise<PettyCashReceipt> => {
    const form = new FormData();
    form.append('file', file);
    return (await axios.post(E.RECEIPTS(voucherId), form, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  },
  downloadReceipt: async (voucherId: string, attachmentId: string): Promise<Blob> =>
    (await axios.get(E.RECEIPT_DOWNLOAD(voucherId, attachmentId), { responseType: 'blob' })).data,
  proposal: async (fundId: string, throughDate?: string): Promise<ReplenishmentProposal> =>
    (await axios.get(E.PROPOSAL(fundId), { params: throughDate ? { throughDate } : {} })).data,
  replenish: async (body: ReplenishRequest): Promise<Replenishment> => (await axios.post(E.REPLENISHMENT, body)).data,
  voidReplenishment: async (id: string): Promise<Replenishment> => (await axios.post(E.REPLENISHMENT_VOID(id))).data,
  count: async (body: CountRequest): Promise<PettyCashCount> => (await axios.post(E.COUNT, body)).data,
};
